import QueryContainer from './QueryContainer';

export default QueryContainer;


// WEBPACK FOOTER //
// ./src/components/Query/index.js